import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import categoryIcons from "../images/lokal/categories.png"
import mracategoryIcons from "../images/lokal/mracategories.png"

import $ from "jquery";
export default class HeaderCategory extends Component {
    locationClick() {
        $(".locationPopUp").show();
    }
    render() {

        let themeId = localStorage.getItem('themeId')
        let subDomainFlag = window.sessionStorage.getItem('subDomainFlag');
        let locationId = localStorage.getItem('locationId');
        return (
            subDomainFlag !== "1" ?
                (((locationId !== null && locationId !== 'null' && locationId !== '' )|| localStorage.getItem('siteGlobalDelivery') === "true")&& subDomainFlag !== '1') ?
                    <div className="headerIcons"><Link to="/category" className="headerImage"><img title="Choose Category" src={themeId === '29' ? mracategoryIcons : categoryIcons} alt="" /></Link></div>
                    :
                   ((localStorage.getItem('isPincodeBased') === "true")&&(locationId == null || locationId == 'null' || locationId == '' )) ? "" :
                    <div className="headerIcons" onClick={this.locationClick}><img title="Choose Category" src={themeId === '29' ? mracategoryIcons : categoryIcons} alt="" /></div>
                : ""
        )
    }
}